import { oktaConfigFromEnv } from '@laborelec/lbe-react/auth';
import { OktaAuth } from '@okta/okta-auth-js';

const oktaAuth = new OktaAuth({
  ...oktaConfigFromEnv(import.meta.env),
  // The org authorization server puts the user's groups in the ID token only when `groups` is requested: the API is
  // called with the ID token and maps them to technodb permissions (see services/Server.tsx).
  scopes: ['openid', 'profile', 'email', 'groups'],
});

export default oktaAuth;
